import { AUTH_ACTIONS } from '../helpers/authActions'

const initialState = {
  isLoading: true,
  isAuthenticated: false,
  error: null
}

export function authReducer (state = initialState, action) {
  switch (action.type) {
    case AUTH_ACTIONS.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload
      }

    case AUTH_ACTIONS.SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload,
        isLoading: false
      }

    case AUTH_ACTIONS.CHECK_AUTH_START:
      return {
        ...state,
        isLoading: true,
        error: null
      }

    case AUTH_ACTIONS.CHECK_AUTH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        error: null
      }

    case AUTH_ACTIONS.CHECK_AUTH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        error: 'Authentication failed'
      }

    case AUTH_ACTIONS.LOGOUT:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        error: null
      }

    default:
      return state
  }
}
